import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { ThongTinThanhly } from "./ThongTinThanhly";
import { LanThanhToan } from "./LanThanhToan";
import { TaiSanThanhLy } from "./TaiSanThanhLy";
import { pushNotification } from "utils/notifications";
import DanhSachTaiSanApi from "../../../../service/danhSachTaiSanApi";
import { useSelector, useDispatch } from "react-redux";
import { currentDate } from "utils/formatDate";
import { getListTaiSan } from "actions/DanhSachTaiSan/";
import ChiTietHopDongApi from "../../../../service/chiTietHopDongApi";
import { convertToNumber } from "utils/numberExtension";
import { formatDayMonth } from "utils/formatDate";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import { TaiSanThanhLyKhongHopDong } from "./TaiSanThanhLyKhongHopDong";
import { AutoCompleteKhachHang } from "./AutoCompleteKhachHang";
export const ThanhLy = (props) => {
  const [hopdong, setDataHopDong] = useState({});
  const ChiTietHopDong = () => {
    ChiTietHopDongApi.getChiTietHopDong1(props.hopdongId).then((response) => {
      setDataHopDong(response.data);
    });
  };
  useEffect(() => {
    ChiTietHopDong();
  }, []);

  //Code
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dataSearch = useSelector((state) => state.dataSearchTaiSan);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  // console.log(user.combo);
  const initData = {
    TaiSanID: props.taiSanId,
    KhachHang_Id: "",
    TenKhachHang: "",
    NgayThanhLy: currentDate(),
    GhiChu: "",
    TienThanhLy: "",
    TienKhachTra: "",
    PhiKhac: "",
  };

  const [dataThanhLy, setDataThanhLy] = useState(initData);

  const UpdateKhachHang = (khachhang) => {
    setDataThanhLy(khachhang);
    //alert(chuno.Phone);
  };

  const updateTextValue = (field) => (e) => {
    setDataThanhLy({
      ...dataThanhLy,
      [field]: e.target.value,
    });
  };
  const onChangeNumber = (field) => (evt) => {
    const value = convertToNumber(evt.target.value);

    setDataThanhLy((prev) => {
      const newData = {
        ...prev,
        [field]: value,
      };

      // ✅ GIỮ NGUYÊN LOGIC:
      // Nhập Tiền thanh lý → Tiền khách trả nhảy theo
      if (field === "TienThanhLy") {
        newData.TienKhachTra = value;
      }

      return newData;
    });

    // validate giữ nguyên
    if ((!value || value === 0) && (field === "TienThanhLy")) {
      setErrors1({
        ...errors1,
        tienThanhLy: "Nhập tiền thanh lý",
      });
      TienThanhLy.current?.focus();
    } else {
      setErrors1({
        ...errors1,
        tienThanhLy: "",
      });
    }
  };

  const onChangeDate = (field) => (evt) => {
    setDataThanhLy({
      ...dataThanhLy,
      [field]: formatDayMonth(evt),
    });
  };

  //Thông báo
  const initErrors = {
    tenKhachHang: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    tienThanhLy: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const TenKhachHang = React.createRef();
  const TienThanhLy = React.createRef();
  const onSubmit = () => {
    if (dataThanhLy.TenKhachHang === "") {
      setErrors({
        ...errors,
        tenKhachHang: "Nhập tên người nhận",
      });
      // TenKhachHang.current.focus();
      return;
    } else if (
      dataThanhLy.TienThanhLy === 0 ||
      dataThanhLy.TienThanhLy === ""
    ) {
      setErrors1({
        ...errors1,
        tienThanhLy: "Nhập tiền thanh lý",
      });
      TienThanhLy.current.focus();
      return;
    }
    setIsSubmitting(true);
    DanhSachTaiSanApi.thanhLy(
      dataThanhLy.TaiSanID,
      dataThanhLy.KhachHang_Id,
      dataThanhLy.TenKhachHang,
      dataThanhLy.NgayThanhLy,
      dataThanhLy.GhiChu,
      dataThanhLy.TienThanhLy,
      dataThanhLy.TienKhachTra,
      dataThanhLy.PhiKhac
    ).then((response) => {
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
        setIsSubmitting(false);
        return;
      } else {
        pushNotification(
          "Thanh lý tài sản thành công.",
          "success",
          "TOP_CENTER",
          1000
        );
        props.onHide();

        dispatch(getListTaiSan(dataSearch));
      }
    });
  };
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/logo-thanh-ly-v2.png" />
          </span>{" "}
          Thanh lý
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse53"
                className="card-header"
                href="#collapse53"
                aria-expanded="true"
                aria-controls="collapse53"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Nội dung thanh lý</h3>
                </a>
              </div>
              <div
                id="collapse53"
                aria-labelledby="headingCollapse53"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            {/* <TextInputOnRow
                              labelClass="label-control"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Thanh lý cho"
                            ></TextInputOnRow> */}
                            <AutoCompleteKhachHang
                              UpdateKhachHang={UpdateKhachHang}
                              dataThanhLy={dataThanhLy}
                              setDataThanhLy={setDataThanhLy}
                              taiSanId={props.taiSanId}
                              errors={errors}
                              setErrors={setErrors}
                            />
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label className=" color7-bold">
                                Ngày thanh lý
                              </label>
                              <DateTimePicker
                                onChange={onChangeDate("NgayThanhLy")}
                                value={convertDate(dataThanhLy.NgayThanhLy)}
                                name="NgayThanhLy"
                              ></DateTimePicker>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Tiền thanh lý"
                              inputProps={{
                                name: "dataThanhLy.TienThanhLy",
                                ref: TienThanhLy,
                                onChange: onChangeNumber("TienThanhLy"),
                                value: formatNumber(dataThanhLy.TienThanhLy),
                              }}
                            ></TextInputOnRow>
                            {errors1.tienThanhLy && (
                              <span className="canh-bao-red">
                                {errors1.tienThanhLy}
                              </span>
                            )}
                          </div>

                          <div className="col-md-6">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Phí khác"
                              inputProps={{
                                name: "dataThanhLy.PhiKhac",
                                // ref: TienTra,
                                onChange: onChangeNumber("PhiKhac"),
                                value: formatNumber(dataThanhLy.PhiKhac),
                              }}
                            ></TextInputOnRow>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label
                                for="projectinput8"
                                className=" color7-bold"
                              >
                                Ghi chú
                              </label>
                              <textarea
                                rows="1"
                                className="form-control input-sm text-era"
                                name="comment"
                                value={dataThanhLy.GhiChu}
                                onChange={updateTextValue("GhiChu")}
                              ></textarea>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Tiền khách trả"
                              inputProps={{
                                name: "dataThanhLy.TienKhachTra",
                                // ref: TienTra,
                                onChange: onChangeNumber("TienKhachTra"),
                                value: formatNumber(dataThanhLy.TienKhachTra),
                              }}
                            ></TextInputOnRow>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {props.hopdongId > 0 ? (
                <>
                  <ul className="nav nav-tabs mt-1 bg-tab">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        id="base-tab1"
                        data-toggle="tab"
                        aria-controls="tab1"
                        href="#tab1"
                        aria-expanded="true"
                      >
                        <h4>Thông tin thanh lý</h4>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="base-tab2"
                        data-toggle="tab"
                        aria-controls="tab2"
                        href="#tab2"
                        aria-expanded="false"
                      >
                        <h4>Lần thanh toán</h4>
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="base-tab2"
                        data-toggle="tab"
                        aria-controls="tab2"
                        href="#tab29"
                        aria-expanded="false"
                      >
                        <h4>Tài sản thanh lý</h4>
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                    <div
                      className="tab-pane active"
                      id="tab1"
                      aria-expanded="true"
                      aria-labelledby="base-tab1"
                    >
                      <ThongTinThanhly hopdong={hopdong} />
                    </div>

                    <div
                      className="tab-pane"
                      id="tab2"
                      aria-labelledby="base-tab2"
                    >
                      <LanThanhToan choVayId={props.choVayId} />
                    </div>

                    <div
                      className="tab-pane"
                      id="tab29"
                      aria-labelledby="base-tab2"
                    >
                      <TaiSanThanhLy
                        hopdong={hopdong}
                        choVayId={props.choVayId}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <ul className="nav nav-tabs mt-1 bg-tab">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        id="base-tab1"
                        data-toggle="tab"
                        aria-controls="tab1"
                        href="#tab1"
                        aria-expanded="true"
                      >
                        <h4>Thông tin thanh lý</h4>
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                    <div
                      className="tab-pane active"
                      id="tab1"
                      aria-expanded="true"
                      aria-labelledby="base-tab1"
                    >
                      <TaiSanThanhLyKhongHopDong taiSanId={props.taiSanId} />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <button
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>{" "}
          &nbsp; Xác nhận&nbsp;
        </button>
      </Modal.Footer>
    </Modal>
  );
};
